export type OtpContactChannel = 'SMS' | 'MAIL';
